import ImagePostback from './ImagePostback';
export default ImagePostback;
